import { GetterTree, MutationTree, ActionTree } from "vuex"

import { sessionKey } from 'Store/keyStore'
import { IProfileForm } from 'Services/account'
import sessionService, { userSessionProfile } from 'Store/module/sessionService'

const state = {

}

const getters = <GetterTree<any, any>>{
  isAuthorized: (state: any) => sessionService.has(),
  token: (state: any) => {
    if (sessionService.has()) {
      return JSON.parse(sessionService.get());
    } else {
      return null;
    }
  }
}

const mutations = <MutationTree<any>>{
  [sessionKey.AUTH_SUCCESS]: (state: any, user: any) => {
    const token = JSON.stringify(user);
    sessionService.set(token);
  },
  [sessionKey.AUTH_LOGOUT]: (state: any) => {
    sessionService.remove();
    userSessionProfile.remove();
  },
  [sessionKey.USER_PROFILE]: (state: any, profile: IProfileForm) => {
    const token = JSON.stringify(profile);
    userSessionProfile.set(token);
  }
}

const actions = <ActionTree<any, any>>{
  [sessionKey.AUTH_LOGOUT]: (context: any) => {
    return new Promise((resolve, reject) => {
      context.commit(sessionKey.AUTH_LOGOUT);
      resolve({
        isSuccess: true
      });
    })
  }
}

export default {
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};

